<template>
    <div v-if="!isReadOnly" class="flex justify-between">
        <AddressAutocomplete
            :actual="actual"
            :readonly="isReadOnly"
            @chose="onChoseAddress" @remove="onRemove" v-model:risultati="risultati"
            v-model:gaddress="address" :placeId="placeId">
            <template v-slot:actual="{actual}">
                <slot name="actual" v-bind:actual="actual"></slot>
            </template>
        </AddressAutocomplete>
    </div>
    <GMap
        v-if="mapVisible"
        :readonly="isReadOnly"
        :marker="marker"
        :center="center"
        v-model:risultati="risultati"
        :zoom="zoom"
        @mapClick="onMapClick"
        class="h-80"></GMap>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import GMap from "@/components/Address/GMap.vue";
import AddressAutocomplete from "@/components/Address/AddressAutocomplete.vue";
import gMapLoader from "@/types";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";

@Options({
    name: 'MapViewer',
    emits: ['update:placeId', 'update:lat', 'update:lng', 'addressInformationChange'],
    components: {
        AddressAutocomplete,
        GMap,
    },
    props: {
        placeId: {
            type: String,
            required: false
        },
        lat: {
            type: [String, Number],
            required: false
        },
        lng: {
            type: [String, Number],
            required: false
        },
    },
})
export default class MapViewer extends Vue {
    marker: any = null
    address: any = null
    center: any | null = {
        lat: 41.9099533,
        lng: 12.3711917
    }
    markerOnCenter = false
    actual: any = null
    zoom = 10
    placeId!: string | null
    risultati: any[] = []

    get mapVisible(){
        return ! ('hide_map' in this.$attrs)
    }

    @Watch('placeId')
    async onChangePlaceId(new_val: any, old_val: any){
        if(new_val){
            const {Geocoder} = await gMapLoader.importLibrary("geocoding");
            const geocoder = new Geocoder();
            geocoder.geocode({
                placeId: this.placeId
            }).then((res: any) => {
                const result = res.results[0]
                if (result) {
                    this.marker = {
                        lat: result.geometry.location.lat(),
                        lng: result.geometry.location.lng(),
                        title: result.formatted_address
                    }
                    this.address = result
                    this.markerOnCenter = true
                    this.center.lat = result.geometry.location.lat()
                    this.center.lng = result.geometry.location.lng()
                    this.actual = this.decodeAddressInformation(result)
                }
            })
        }
    }

    get isReadOnly() {
        if('readonly' in this.$attrs){
            return this.$attrs['readonly'] ?? false
        }
        return false
    }

    onChoseAddress(address: any) {
        this.address = address
        this.marker = {
            lat: address.geometry.location.lat(),
            lng: address.geometry.location.lng(),
            title: address.formatted_address
        }
        this.markerOnCenter = true
        this.center.lat = address.geometry.location.lat()
        this.center.lng = address.geometry.location.lng()
        this.$emit('update:placeId', address.place_id)
        this.$emit('update:lat', address.geometry.location.lat())
        this.$emit('update:lng', address.geometry.location.lng())
        this.actual = this.decodeAddressInformation(address)
        this.$emit('addressInformationChange', this.actual)
    }

    decodeAddressInformation(gAddress:any){
        return {
            formatted_address: gAddress.formatted_address,
            street_number: gAddress.address_components.find((e:any)=>e.types.includes('street_number'))?.long_name,
            route: gAddress.address_components.find((e:any)=>e.types.includes('route'))?.long_name,
            locality: gAddress.address_components.find((e:any)=>e.types.includes('locality'))?.long_name,
            administrative_area_level_2: gAddress.address_components.find((e:any)=>e.types.includes('administrative_area_level_2'))?.long_name,
            province: gAddress.address_components.find((e:any)=>e.types.includes('administrative_area_level_2'))?.short_name,
            administrative_area_level_1: gAddress.address_components.find((e:any)=>e.types.includes('administrative_area_level_1'))?.long_name,
            region: gAddress.address_components.find((e:any)=>e.types.includes('administrative_area_level_1'))?.short_name,
            country: gAddress.address_components.find((e:any)=>e.types.includes('country'))?.long_name,
            postal_code: gAddress.address_components.find((e:any)=>e.types.includes('postal_code'))?.long_name,
        }
    }

    onMapClick(event: any) {
        // this.marker = {
        //     lat: event.latLng.lat(),
        //     lng: event.latLng.lng(),
        //     title: ''
        // }
        this.center.lat = null
        this.center.lng = null
        // this.$emit('update:placeId', event.place_id)
        // this.$emit('update:lat', event.latLng.lat())
        // this.$emit('update:lng', event.latLng.lng())
    }

    onRemove() {
        this.marker = null
        this.address = null
        this.actual = null
        this.$emit('update:placeId', null)
        this.$emit('update:lat', null)
        this.$emit('update:lng', null)
        this.$emit('addressInformationChange', null)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
